import React, { useCallback, useEffect, useState } from "react";
import HeaderContent from "@/layout/HeaderContent";
import Loading from "@/components/Loading";
import { API_BASE_URL } from "@/config/serverApiConfig";
import axios from "axios";
import { useParams } from "react-router-dom";

const Notification = () =>{
    
    let {id} = useParams();
    const [notification, setNotification] = useState();
    let [list, setList] = useState([{
        id: id,
        content: "",
        created_at: "",
        type: "",
     }]);
    
    
    
    useEffect(() => {
        axios.post(`${API_BASE_URL}admin/updateNotification`,{id:id})
        .then(res => {
            
            setList(res.data.result);
        }
        );
    }, []);

    


    return (
        <div>
            <HeaderContent />
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Notification</h4>
                            </div>
                            
                            <div className="card-body">
                                <h3 className="card-title">{list.type}</h3>
                                <p className="card-text">{list.content}</p>

                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Notification;

                                